import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "ig-home" */ './views/home.vue'),
        meta: {
            auth: undefined,
            title: `home.title`,
        }
    },
];

export default routes;